import { createMuiTheme } from "@material-ui/core/styles";
var defiTheme = createMuiTheme({
  palette: {
    default: {
      main: "rgb(232, 232, 232)"
    },
    primary: {
      light: "#4f6182",
      main: "#334058",
      dark: "#1a2a47",
      contrastText: "#fff"
    },
    secondary: {
      light: "#fff",
      main: "#e8e8e8",
      dark: "#b6b6b6",
      contrastText: "#000"
    }
  },
  overrides: {
    MuiButtonBase: {
      root: {
        padding: "6px 16px"
      }
    },
    MuiButton: {
      root: {
        color: "inherit",
        textTransform: "none"
      },
      text: {
        color: "white",
        padding: "6px 16px"
      }
    },
    MuiIconButton: {
      root: {
        color: "inherit"
      }
    },
    MuiSvgIcon: {
      root: {
        color: "inherit"
      }
    },
    MuiInputBase: {
      input: {
        padding: "10px 8px"
      }
    },
    MuiInput: {
      root: {
        fontSize: "0.75pem"
      }
    },
    MuiList: {
      root: {
        zIndex: "10"
      }
    },
    MuiMenuItem: {
      root: {
        fontSize: "0.75pem",
        minHeight: "30px"
      }
    },
    MuiPaper: {
      root: {
        marginRight: "0px",
        padding: "0px"
      }
    },
    MuiTableCell: {
      head: {
        fontWeight: "bold",
        color: "black"
      }
    },
    MuiBox: {
      root: {
        padding: "0px 0px 2px 4px"
      }
    },
    MuiBadge: {
      badge: {
        fontSize: "1rem"
      }
    },
    MuiFormControl: {
      marginTest: {
        margin: "5px 0 0 0"
      }
    },
    MuiFormControlLabel: {
      root: {
        display: "inherit !important"
      }
    }
  }
});
export default defiTheme;